import React from 'react'
import { Toolbar, Link, Container } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    navbar: {
        fontSize: '1.1rem',
        backgroundColor: theme.palette.primary.main,
        padding: '1rem 0',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            justifyContent: 'flex-start',
        },
    },
    link: {
        color: '#FFFFFF',
        textDecoration: 'none',
        marginBottom: '1rem',
        [theme.breakpoints.up('md')]: {
            marginLeft: '2rem',
            marginBottom: 0,
        },
        '&:first-child': {
            marginLeft: 0,
        },
        '&:last-child': {
            marginBottom: 0,
        },
    },
    activeLink: {
        borderBottom: '4px solid #FFFFFF',
    },
    disabledLink: {
        color: 'lightgray',
        cursor: 'pointer',
    },
    cobrandCardsTooltip: {
        fontSize: '0.9rem',
    },
}))

const Navbar = (props) => {
    const classes = useStyles()
    const { baseUrl } = props

    return (
        <Toolbar className={classes.navbar}>
            <Container maxWidth="lg" className={classes.container}>
                <NavLink
                    to={'/gift-cards-for-business/'}
                    className={classes.link}
                    activeClassName={classes.activeLink}
                    exact
                >
                    Place order
                </NavLink>
                <NavLink
                    to={'/gift-cards-for-business/cobrand-cards/'}
                    className={classes.link}
                    activeClassName={classes.activeLink}
                    exact
                >
                    Co-brand cards
                </NavLink>
                <Link
                    href={`${baseUrl}/account/orders`}
                    className={classes.link}
                >
                    Order history
                </Link>
            </Container>
        </Toolbar>
    )
}

export default Navbar
